"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useWebChatUIContext;

var _react = require("react");

var _WebChatUIContext = _interopRequireDefault(require("./WebChatUIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useWebChatUIContext() {
  var context = (0, _react.useContext)(_WebChatUIContext.default);

  if (!context) {
    throw new Error('This hook can only be used on a component that is a descendant of <Composer>');
  }

  return context;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VXZWJDaGF0VUlDb250ZXh0IiwiY29udGV4dCIsInVzZUNvbnRleHQiLCJXZWJDaGF0VUlDb250ZXh0IiwiRXJyb3IiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VXZWJDaGF0VUlDb250ZXh0LmpzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHVzZUNvbnRleHQgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCBXZWJDaGF0VUlDb250ZXh0IGZyb20gJy4vV2ViQ2hhdFVJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVdlYkNoYXRVSUNvbnRleHQoKSB7XG4gIGNvbnN0IGNvbnRleHQgPSB1c2VDb250ZXh0KFdlYkNoYXRVSUNvbnRleHQpO1xuXG4gIGlmICghY29udGV4dCkge1xuICAgIHRocm93IG5ldyBFcnJvcignVGhpcyBob29rIGNhbiBvbmx5IGJlIHVzZWQgb24gYSBjb21wb25lbnQgdGhhdCBpcyBhIGRlc2NlbmRhbnQgb2YgPENvbXBvc2VyPicpO1xuICB9XG5cbiAgcmV0dXJuIGNvbnRleHQ7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFFQTs7OztBQUVlLFNBQVNBLG1CQUFULEdBQStCO0VBQzVDLElBQU1DLE9BQU8sR0FBRyxJQUFBQyxpQkFBQSxFQUFXQyx5QkFBWCxDQUFoQjs7RUFFQSxJQUFJLENBQUNGLE9BQUwsRUFBYztJQUNaLE1BQU0sSUFBSUcsS0FBSixDQUFVLDhFQUFWLENBQU47RUFDRDs7RUFFRCxPQUFPSCxPQUFQO0FBQ0QifQ==